import { DatePipe, DecimalPipe } from "@angular/common";
import { Component, InputSignal, input, inject, computed } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import { InvoiceDto } from "../../../../../../../api/models/fraud.models";
import { purchaseCheckPopAnimation } from "../../../../../../animations/pricing-animations";
import { getPriceRange, groupCostProviders } from "../../../../../../utils/pricing.utils";
import { CropWithDotsCenterPipe } from "../../../../../../pipes/crop-with-dots-center.pipe";
import { CopyToClipboardCopiedDirective } from "../../../../../../directives/copy-to-clipboard-copied.directive";


@Component({
  selector: 'app-plan-upgrade-paid',
  imports: [
    MatIcon,
    DatePipe,
    DecimalPipe,
    CopyToClipboardCopiedDirective,
    CropWithDotsCenterPipe
],
  templateUrl: './plan-upgrade-paid.component.html',
  animations: [purchaseCheckPopAnimation],
  styleUrl: './plan-upgrade-paid.component.scss',
  host:{
    class: 'flex min-h-full overflow-hidden'
  }
})
export class PlanUpgradePaidComponent {
  public readonly invoice: InputSignal<InvoiceDto> = input.required<InvoiceDto>();

  readonly matDialogRef = inject(MatDialogRef);
  readonly router = inject(Router);

  readonly priceRange = computed(() => {
    const plan = this.invoice()?.userPlan;
    if (!plan) return '0.00';
    return getPriceRange(groupCostProviders(plan));
  });

  // onDownloadInvoice(): void {
  //   this.matDialogRef.close();
  //   this.router.navigate(['/balance'], { queryParams: { tabIndex: 1 } });
  // }

  onGoDashboard(): void {
    this.matDialogRef.close();
    this.router.navigate(['/']);
  }
}
